var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt_3 content_box"},[_c('title-box',{attrs:{"text":"实景案例"}}),_c('el-carousel',{staticClass:"mt_3",attrs:{"interval":4000,"type":"card","height":"300px"}},_vm._l((_vm.carouselList),function(item,index){return _c('el-carousel-item',{key:index},[_c('div',{staticClass:"h_100",style:({
          background: 'url(' + item + ') no-repeat center top',
          backgroundSize: '100% auto',
        })})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }